import { render, staticRenderFns } from "./bidOpeningSummary.vue?vue&type=template&id=388c3b12&scoped=true"
import script from "./bidOpeningSummary.vue?vue&type=script&lang=js"
export * from "./bidOpeningSummary.vue?vue&type=script&lang=js"
import style0 from "./bidOpeningSummary.vue?vue&type=style&index=0&id=388c3b12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c3b12",
  null
  
)

export default component.exports